import type { LucideIcon } from "lucide-react";
import { Inbox, UserRound } from "lucide-react";

export type CommunitySuiteView = "concerns" | "residents";

export type CommunitySuiteViewConfig = {
  id: CommunitySuiteView;
  label: string;
  icon: LucideIcon;
};

export const COMMUNITY_SUITE_VIEWS: CommunitySuiteViewConfig[] = [
  { id: "concerns", label: "Concerns", icon: Inbox },
  { id: "residents", label: "Residents", icon: UserRound },
];
